import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { ApiService } from '../../root-services/api.service';
import { EditionListService } from '../../editions/edition.service';

import { Program } from './../../models/program/program';
import { Group } from './../../models/program/group';

// RxJS Interfaces
import { Observable } from 'rxjs/Observable';
import { NewUser } from '../../models/program/new-user';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-add-new-user',
  templateUrl: './add-new-user.component.html',
  styleUrls: ['./add-new-user.component.less']
})

export class AddNewUserComponent implements OnInit {
  @Input() adminOrUser: 'admin' | 'user';
  @Input() showButton = true;
  @Input() newUserData: string;
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  // This property is used to send the formgroup model up to parent component rather than signing up user directly
  @Output() outputNewUser: EventEmitter<NewUser> = new EventEmitter<NewUser>();
  public invite: FormGroup;
  public groups: Observable<Group[]>;
  public programs: Observable<Program[]>;
  public selectedProgram: number;
  public selectedGroup: number;
  public inTeam: boolean;
  public outputNotAddDirectly: boolean;
  public ssoFieldName: string;

  constructor(
    private editionList: EditionListService,
    private _fb: FormBuilder,
    private api: ApiService
  ) { }

  ngOnInit(): void {
    let self = this;
    this.programs = this.getPrograms();

    this.outputNotAddDirectly = this.outputNewUser.observers.length > 0


    this.editionList.getEditionDetailsObservable().map(edition => edition['sso_field_name']).subscribe(ssoFieldName => {
      this.ssoFieldName = ssoFieldName;
      let formGroup: any = {
        first_name: [''],
        last_name: [''],
        email: [self.newUserData.includes('@') ? self.newUserData : '', [Validators.required, Validators.email]],
      }
      if (ssoFieldName) {
        formGroup = {
          ...formGroup,
          sso_id: ['', Validators.required]
        }
      }
      if (this.adminOrUser === 'admin') {
        formGroup = {
          ...formGroup,
          program: ['', Validators.required],
          team: ['', Validators.required]
        }
      }
      self.invite = this._fb.group(formGroup);
      window.setTimeout(() => {
        let focusEl = document.getElementById('first_name')
        if (focusEl) focusEl.focus();
      }, 0)
    });
   }

   /**
    * Public Methods
    */


   public setProgram(id: string): void {
     let programId: number = parseInt(id, 10);
     const control: FormControl = <FormControl>this.invite.controls['program'];
     const groupCtrl: FormControl = <FormControl>this.invite.controls['team'];

     this.selectedGroup = null;
     this.selectedProgram = programId;
     this.groups = this.getGroups(programId);
     groupCtrl.patchValue('');
     control.patchValue(programId);
   }

   public setGroup(id: string): void {
     let groupId: number = parseInt(id, 10);
     const control: FormControl = <FormControl>this.invite.controls['team'];

     this.selectedGroup = groupId;
     control.patchValue(groupId);
   }

   public addUser(): void {
      if (this.invite.valid && this.outputNotAddDirectly) {
        this.outputNewUser.emit(this.invite.value);
      } else {
        this.inviteUser();
      }
   }

   public inviteUser(): Observable<any> {
     if (this.invite.valid) {
      let model = this.invite.value;
      let observable = this.addUserToGroup(model.program, model.team, model).share();
      observable.subscribe(res => {});
      return observable;
     }
   }

   /**
    * Private Methods
    */

    private getPrograms(): Observable<Program[]> {
      return this.api.get('/programs')
                     .map(res => res.json() as Program[])
                     .catch(this.handleError);
    }

    private getGroups(id: number): Observable<Group[]> {
      return this.api.get(`/programs/${id}/groups`)
                     .map(res => res.json() as Group[])
                     .catch(this.handleError);
    }

    private addUserToGroup(programId: number, groupId: number, body: any): Observable<any> {
      return this.api.post(`/programs/${programId}/groups/${groupId}/users`, body)
              .map(res => {
                this.reset.emit(true);
                return parseInt(res.headers.get('X-Entity-Id'), 10);
              })
              .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
      console.log('An error occurred:', error);
      return Promise.reject(error);
    }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/add-new-user/add-new-user.component.ts